<template>
  <div class="innerBox">

    <h2 class="mb-4">Daftar Asuransi</h2>
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    
    <vue-universal-table
      :special_buttons="vue_universal_table.special_buttons"
      :buttons="vue_universal_table.buttons"
      :dummy_table="false"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :process_data="vue_universal_table.process_data"
      api_url="/api/v1/insurance/company"

      @onEdit="editInsurance"
      @onDelete="deleteInsurance"
      @onRegistrasiAsuransi="addInsurance"
      @onPriceList="showPriceList"
    ></vue-universal-table>

    <new-insurance
      v-if="modal.add"
      @closeModal="modal.add = false"
      @updateTable="vue_universal_table.update++"
    ></new-insurance>

    <edit-insurance
      v-if="modal.edit"
      :editObject="editObject"
      @closeModal="modal.edit = false"
      @updateTable="vue_universal_table.update++"
    ></edit-insurance>
    <!--  -->
  </div>
</template>

<script>
  // Library
  import moment from 'moment'

  // Children Component
  import NewInsurance from './children/newInsurance'
  import EditInsurance from './children/editInsurance'

  export default {
    data () {
      const start = moment().startOf('month').format('YYYY-MM-DD');
      let end  = new moment().format('YYYY-MM-DD')

      return {
        modal : {
          add : false,
          edit : false
        },
        editObject : null,
        data : null,
        filter: {
          start: start,
          end: end,
          search : ''
        },
        mobile : this.isMobile(),
        selected : {
          date : `${start} to ${end}`,
        },
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        showNewUserModal : false,
        apiLoading: true,
        vue_universal_table : {
          process_data : `
            for(var i = 0 ; i < data.length ; i++) {
              data[i].email = data[i].email.split(',')
            }
          `,
          update: 0,
          special_buttons : ['registrasiAsuransi'],
          buttons : [
            {
              title : 'PriceList',
              class : 'btn-outline-secondary'
            },
            {
              title : 'Edit',
              class : 'btn-outline-primary fas fa-edit'
            },
            {
              title : 'Delete',
              variable : 'id',
              class : 'btn-outline-danger fa fa-times'
            }
          ],
          fields : [
            {
              title : 'Asuransi No.',
              variable : 'id'
            },
            {
              title : 'Nama',
              variable : 'name'
            },
            {
              title : 'Nama Perusahaan',
              variable : 'company_name'
            },
            {
              title : 'Email' ,
              variable : 'email'
            },
            {
              title : 'Alamat',
              variable : 'address'
            },
            {
              title : 'Nomor Telefon',
              variable : 'phone_number'
            },
            {
              title : 'Tanggal Registrasi',
              variable : 'created_at'
            }
          ]
        }
      }
    },
    components : {
      EditInsurance,
      NewInsurance
    },
    mounted () {
    },
    methods : {
      // createNewWorkOrder () {
      //   this.$router.push({name : 'WorkOrderFormNew'})
      // },
      // viewDetailWO (x) {
      //   this.$router.push({name : 'WorkOrderDetail', query: {wo:x.replace(/"/g, "")}})
      // }
      editInsurance (obj) {
        this.modal.edit = true
        this.editObject = JSON.parse(JSON.stringify(obj))
      },
      deleteInsurance (id) {
        let url = '/api/v1/insurance/company/' + id

        this.$http.delete(url)
        .then((resp) => {
          alert('Perusahaan Berhasil Di Delete')
          this.vue_universal_table.update++
        })
        .catch((err) => {
          console.log(err)
        })
      },
      addInsurance() {
        this.modal.add = true
      },
      showPriceList(obj) {
        this.$router.push({name : 'EstimatorInsurancePriceList' , params: { id: JSON.stringify(obj) }})
      }
    },
    watch : {
      'selected.date'(){
        var date = this.selected.date.split(" to ");
        this.filter.start = date[0]
        this.filter.end = date[1] ? date[1] : date[0]
      }
    }
  }
</script>

<style scoped>
  
</style>